<template>
  <section class="d-flex justify-content-center align-items-center">
		<span class="chattime" :class="{oneWeekOrMore : oneWeekOrMore == true, hide: !show}">{{ convertedTime }}</span>
	</section>
</template>

<script>
import moment from "@modules/moment-timezone";
export default {
  name: 'ChatTime',
  components: {
  },
  props: {
		time: {
			required: true
		}
  },
  data() {
    return {
			show: true,
			oneWeekOrMore: false
    }
  },
  computed: {
		convertedTime() {
			let ct = moment.utc(this.time).tz(Ambition.Globals.tenant.user.timezone);
			let m;

			if (this.isToday(ct)) {

                m = ct.fromNow();

			} else if(this.isYesterday(ct)) {

				m = ct.format('dddd LT');

			} else if (this.isWithinAWeek(ct)) {

				m = ct.format('dddd LT');

			} else if (this.isOneWeekOrMore(ct)) {

				this.oneWeekOrMore = true;
				m = ct.format('llll');

			}
			return m
		}
  },
  watch: {
  },
  mounted() {
  },
  updated() {
  },
  activated() {
  },
  methods: {
		isToday(m) {
				let TODAY = this.$moment().startOf('day');
				return m.isSame(TODAY, 'd');
		},
		isYesterday(m) {
				let YESTERDAY = this.$moment().subtract(1, 'days').startOf('day');
				return m.isSame(YESTERDAY, 'd');
		},
		isWithinAWeek(m) {
				let A_WEEK_OLD = this.$moment().subtract(7, 'days').startOf('day');
				return m.isAfter(A_WEEK_OLD);
		},
		isOneWeekOrMore(m) {
				return !this.isWithinAWeek(m);
		}
  }
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';
	.chattime {
	    padding: 0rem 1rem;
        background: #e6e6e6;
        border-radius: 20px;
        font-size: 0.7rem;
        color: #676565;
		opacity: 0.6;

        &.hide {
            opacity: 0.5;
        }
	}
</style>
